var MultipleGuestServiceProviderModel = require('./multiple-guest-service-provider');

var MultipleGuestModel = Backbone.Epoxy.Model.extend({
  initialize: function() {
    Backbone.Validation.bind(this, { liveValidation: true });

    this.listenTo(this, 'change:storeId', _.bind(this.resetGuestsServiceProviders, this));
    this.listenTo(this, 'change:numberOfGuests', _.bind(this.setGuestsServiceProviders, this));
    this.listenTo(this.get('serviceProviders'), 'provider:changed', _.bind(this.notifyCollectionChanges, this))

  },

  cleanup: function() {
    this.stopListening();
  },

  defaults: {
    storeId: -1,
    numberOfGuests: 0, // just me
    serviceProviders: new Backbone.Collection(null, { model: MultipleGuestServiceProviderModel }),
    overWaitTimeShown: false
  },

  resetGuestsValidation: function() {
    this.set('overWaitTimeShown', false);
    _.each(this.get('serviceProviders').models, function(serviceProvider) {
      serviceProvider.set('validationSuspended', true);
    });
  },

  reIndexGuests: function() {
    _.each(this.get('serviceProviders').models, function(serviceProvider, index) {
      serviceProvider.set('index', index);
      serviceProvider.set('guest', index + 1);
    });
  },

  resetGuestsServiceProviders: function() {
    _.each(this.get('serviceProviders').models, function(serviceProvider) {
      serviceProvider.set('serviceId', bookedby.staticData.storeGroupSettings.defaultCentralService);
      serviceProvider.set('providerId', null);
    });
  },

  reCheckGuestsServiceProviders: function() {
    _.each(this.get('serviceProviders').models, _.bind(function(serviceProvider) {
      if (!bookedby.app.serviceManager.employeeByGuestWaitTimes[serviceProvider.get('index')]) { // if no entry remove this model
        this.get('serviceProviders').remove(serviceProvider);
      } else {
        var availableEmployees = _.keys(bookedby.app.serviceManager.employeeByGuestWaitTimes[serviceProvider.get('index')]);

        if (availableEmployees.length == 0) { // if no entry remove this model
          this.get('serviceProviders').remove(serviceProvider);
        } else if (serviceProvider.get('providerId') != null && !_.contains(availableEmployees, '' + serviceProvider.get('providerId'))) {
          serviceProvider.set('providerId', null);
        }
      }

      serviceProvider.trigger('waitTimesUpdated');
    }, this));
  },

  setGuestsServiceProviders: function() {

    var currentGuests = this.get('serviceProviders').length;
    var diff = 0;
    var serviceProvider = null;

    if (this.get('numberOfGuests') == -1) { // shouldn't happen
      this.get('serviceProviders').reset();
      return;
    }

    if (this.get('numberOfGuests') == currentGuests) {
      return;
    }

    if (this.get('numberOfGuests') > currentGuests) {

      diff = this.get('numberOfGuests') - currentGuests;

      for (var i = 0 ; i < diff ; i++) {
        serviceProvider = new MultipleGuestServiceProviderModel();
        serviceProvider.set('serviceId', bookedby.staticData.storeGroupSettings.defaultCentralService);
        serviceProvider.set('guest', this.get('serviceProviders').length + 1);
        serviceProvider.set('index', this.get('serviceProviders').length);

        this.get('serviceProviders').push(serviceProvider);
      }
    }

    if (this.get('numberOfGuests') < currentGuests) {
      diff = currentGuests - this.get('numberOfGuests');

      for (var j = 0 ; j < diff ; j++) {
        this.get('serviceProviders').remove(this.get('serviceProviders').at(this.get('serviceProviders').length - 1));
      }

      //if (this.get('serviceProviders').length == 0) {
      //  this.get('serviceProviders').reset({});
      //  this.get('serviceProviders').at(0).set('serviceId', bookedby.staticData.storeGroupSettings.defaultCentralService);
      //}
    }
  },

  notifyCollectionChanges: function(model) {
    this.trigger('guests:changed', model);
  },

  computeGuestSearch: function() {
    var guests = [];
    _.each(this.get('serviceProviders').models, function(serviceProvider, idx) {
      var service = serviceProvider.get('service') ? serviceProvider.get('service').get('id') : null;
      var provider = serviceProvider.get('provider') ? serviceProvider.get('provider').get('id') : null;
      var guest = service;

      if (provider != null) {
        guest += '-' + provider;
      }

      guests.push(guest);
    });

    return guests;
  },

  computeFirstGuestSearch: function() {
    var firstGuest = this.get('serviceProviders').models[0];
    var service = firstGuest.get('service');
    var provider = firstGuest.get('provider');
    if (provider) {
      return service.get('id') + '-' + provider.get('id');
    } else {
      return service.get('id');
    }
  },

  computeRestGuestSearch: function() {
    var guests = [];
    _.each(this.get('serviceProviders').models.slice(1), function(serviceProvider, idx) {
      var service = serviceProvider.get('service') ? serviceProvider.get('service').get('id') : null;
      var provider = serviceProvider.get('provider') ? serviceProvider.get('provider').get('id') : null;
      var guest = service;

      if (provider != null) {
        guest += '-' + provider;
      }

      guests.push(guest);
    });

    return guests;
  },

  getFullGuestInfo: function() {
    return this.get('serviceProviders').map(function(guest) {
      return {
        serviceId:  guest.get('service') ? guest.get('service').get('id') : null,
        providerId: guest.get('provider') ? guest.get('provider').get('id') : null,
        firstName: guest.get('firstName'),
        lastName: guest.get('lastName')
      }
    })
  },

  allGuestsValid: function() {
    console.log(this.get('serviceProviders'));
    return this.get('serviceProviders').reduce(function(memo, guest) {
      return guest.isValid(true) && memo;
    }, true);
  },

  parseGuestsName: function() {
    _.each(this.get('serviceProviders').models, function(guestLineSelectorModel) {
      var fullNameArgs = guestLineSelectorModel.get('fullName').split(' ');
      guestLineSelectorModel.set('firstName', fullNameArgs[0]);
      guestLineSelectorModel.set('lastName', fullNameArgs.slice(1).join(' '));
    });
  },

  getMinWaitTime: function() {
    var minTime = Number.MAX_VALUE;

    _.each(this.get('serviceProviders').models, function(serviceProvider) {
      if (serviceProvider.get('provider')) {
        var waitTime = bookedby.app.serviceManager.employeeByGuestWaitTimes[serviceProvider.get('guest')][+serviceProvider.get('provider').get('id')].waitTime;

        minTime = Math.min(minTime, waitTime);
      } else {
        minTime = Math.min(minTime, _.min(_.map(bookedby.app.serviceManager.employeeByGuestWaitTimes[serviceProvider.get('guest')], function(x) { return x.waitTime; })));
      }
    });

    return minTime;
  },

  computeds: { }
});

module.exports = MultipleGuestModel;
